"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useSnackbar = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _css2 = _interopRequireDefault(require("@styled-system/css"));

var _Dialog = require("reakit/Dialog");

var _Portal = require("reakit/Portal");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = {
  autoHideDuration: _propTypes.number,
  children: _propTypes.node.isRequired,
  hide: _propTypes.func.isRequired,
  hideOnClickOutside: _propTypes.bool,
  visible: _propTypes.bool
};
var defaultProps = {
  autoHideDuration: null,
  hideOnClickOutside: false,
  visible: false
};

var useSnackbar = function useSnackbar(initialState) {
  var state = _objectSpread(_objectSpread({}, initialState), {}, {
    modal: false,
    animated: true
  });

  return (0, _Dialog.useDialogState)(state);
};

exports.useSnackbar = useSnackbar;
var Snackbar = (0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "e13h3b4a0"
} : {
  target: "e13h3b4a0",
  label: "Snackbar"
})(function (_ref) {
  var theme = _ref.theme;
  return (0, _css2["default"])(_defineProperty({
    '&[data-enter]': {
      opacity: 1
    },
    bottom: 2,
    left: 2,
    opacity: 0,
    position: 'fixed',
    right: 2,
    transition: 'opacity 0.2s ease',
    zIndex: 'toast'
  }, theme.mq.up('600px'), {
    bottom: 6,
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  }));
});

var Component = function Component(_ref2) {
  var autoHideDuration = _ref2.autoHideDuration,
      _children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["autoHideDuration", "children"]);

  var visible = props.visible,
      hide = props.hide;
  (0, _react.useEffect)(function () {
    if (autoHideDuration && visible) {
      var timer = setTimeout(function () {
        hide();
      }, autoHideDuration);
      return function () {
        return clearTimeout(timer);
      };
    }

    return undefined;
  }, [autoHideDuration, visible, hide]);

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, _objectSpread(_objectSpread({}, props), {}, {
      children: function children(dialogProps) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(Snackbar, _objectSpread(_objectSpread({}, dialogProps), {}, {
          children: _children
        }));
      }
    }))
  });
};

Component.displayName = 'Snackbar';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Snackbar.js.map